$(document).ready(function ($) {
    // ADD AND REMOVE GREYSCALE
    $('.greyscale-filter-button').click(function () {
        $("html").toggleClass("greyscale-filter");
    });
});

$(document).ready(function() {
    // Geht jeden listblock durch
    $('.listblock').each(function() {
        var $listblock = $(this);

        // HIER WAR DER FEHLER: Wir suchen jetzt allgemein nach der Klasse .headline3 (egal ob div oder h3)
        var $headline = $listblock.find('.headline3');

        // Prüfen, ob der Text übereinstimmt
        if ($headline.text().trim() === 'Kristina und Andy Hausen') {

            var $textWrapper = $listblock.find('.text-wrapper');

            // Das erste .person-text-inner greifen (das ist das mit dem Sternchen)
            var $firstPersonTextInner = $textWrapper.find('.person-text-inner').first();

            if ($firstPersonTextInner.length > 0) {
                // Element klonen
                var $clone = $firstPersonTextInner.clone();

                // Datum in der Kopie ändern
                $clone.find('span.date').text('11.03.1988');

                // Die Kopie direkt nach dem Original-Sternchen einfügen
                $firstPersonTextInner.after($clone);
            }
        }
    });
});

$(document).ready(function() {
    // 1. Suche direkt alle .headline3 Elemente auf der Seite
    $('.headline3').each(function() {
        var $headline = $(this);

        // 2. Prüfen, ob genau diese Headline den gesuchten Text hat
        if ($headline.text().trim() === 'Kristina und Andy Hausen') {

            // 3. Gehe zum direkten Eltern-Container dieses Eintrags
            var $personTextContainer = $headline.closest('.person-text');

            // 4. Suche in genau diesem Container nach den .person-text-inner Elementen
            $personTextContainer.find('.person-text-inner').each(function() {
                var $inner = $(this);

                // 5. Prüfen, ob es das Element mit dem Sternchen ist
                if ($inner.find('.condolence-icon').text().trim() === '＊') {

                    // 6. HTML auslesen, Text ersetzen und wieder einfügen
                    var currentHtml = $inner.html();
                    var newHtml = currentHtml.replace('in 11.03.1988', 'und 11.03.1988');

                    $inner.html(newHtml);
                }
            });
        }
    });
});